import { put, call } from 'redux-saga/effects';
import {
    getAllTemplateSuccessAction,
    getAllTemplateFailureAction,
    createTemplateFailureAction,
    createTemplateSuccessAction,
    getAllTemplateRequestAction
} from '../actions/templateActions';
import { END_POINTS } from '../../api/endpoints';
import { API } from '../../api/api';

// ------ get all templates ------

export function* getAllTemplates() {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const templateResponse = yield call(
            API.get,
            `${baseUrl}${END_POINTS.allTemplates}`,
        );

        if (!templateResponse.success) {
            throw new Error(templateResponse.message)
        }
        yield put(getAllTemplateSuccessAction(templateResponse.data));
    } catch (error) {
        yield put(getAllTemplateFailureAction(error.message));
    }
}


//  create template 

export function* createTemplate(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const templateResponse = yield call(
            API.post,
            `${baseUrl}${END_POINTS.allTemplates}`,
            {
                ...action.payload.body
            },
        );

        if (!templateResponse.success) {
            throw new Error(templateResponse.message)
        }
        yield put(createTemplateSuccessAction(templateResponse.data));
        yield put(getAllTemplateRequestAction())
    } catch (error) {
        yield put(createTemplateFailureAction(error.message));
    }
}